import { APIClient } from '@/services'
import { CommunityFeed } from '@/types'
import { formatNumberToShort } from '@/utils'
import { memo, useCallback } from 'react'
import { ActionButton } from '../../atoms/ActionButton'
import { FeedCommentDrawer } from '../../CommentList'

const UnMemoizedComment = ({ item }: { item: CommunityFeed }) => {
  const commentCount = item?.comments

  const formattedCommentCount = formatNumberToShort(commentCount)

  const handleComment = useCallback(async () => {
    const authorized = APIClient.UnknownProfile.maybeOpenRegistrationWall()

    if (!authorized) return

    FeedCommentDrawer.toggle()
  }, [])

  return (
    <ActionButton
      icon='comment'
      text={formattedCommentCount}
      onPress={handleComment}
    />
  )
}

export const Comment = memo(UnMemoizedComment, (prevProps, nextProps) => {
  return prevProps?.item?.comments === nextProps?.item?.comments
})
